import { render, staticRenderFns } from "./FeaturedButton.vue?vue&type=template&id=644e8414&"
import script from "./FeaturedButton.vue?vue&type=script&lang=js&"
export * from "./FeaturedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports